import {createApp} from 'vue';
import OrderingCost from './OrderingCost.vue';
import {createBootstrap} from 'bootstrap-vue-next';
import VueMultiselect from 'vue-multiselect';

$(document).ready(/\/faculty-management\/ordering-cost$/.test(window.location.pathname)&&function() {
  const container = $('#vue-container');

  createApp(OrderingCost, container.data())
     .use(createBootstrap())
      .component('VMultiselect', VueMultiselect)
      .mount(container[0]);
});
